// import { Navigate, Outlet } from "react-router-dom";
// import { useAuth } from "context/AuthContext";

// const PrivateRoute = () => {
//   const { isAuthenticated } = useAuth();
//   console.log("isAuthenticated", isAuthenticated);
//   return isAuthenticated ? <Outlet /> : <Navigate to="/sign-in" />;
// };

// export default PrivateRoute;

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { CircularProgress } from "@mui/material";

const PrivateRoute = () => {
  const { isAuthenticated, authLoading } = useAuth();
  const location = useLocation();
  if (authLoading) {
    return (
      <></>
      //   <div
      //     style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}
      //   >
      //     <CircularProgress />
      //   </div>
    );
  }

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/authentication/sign-in" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
